import React from "react";

interface FriendsProps {
    className?: string
}

export function Friends({className}: FriendsProps) {
    return (
        <div className={className} id={"friends"}>
            <a className="button" href="https://jacksondam.com" target="_blank" rel="noopener noreferrer">Jackson Dam</a>
            <a className="button" href="https://andreig.dev" target="_blank" rel="noopener noreferrer">Andrei Ghiță</a>
            <a className="button" href="https://lukeormiston.com" target="_blank" rel="noopener noreferrer">Luke Ormiston</a>
            <a className="button" href="https://frasermiller.dev" target="_blank" rel="noopener noreferrer">Fraser Miller</a>
            <a className="button" href="https://andreiboghean.com" target="_blank" rel="noopener noreferrer">Andrei Boghean</a>
            <a className="button" href="https://mrktrnbll.dev" target="_blank" rel="noopener noreferrer">Mark Turnbull</a>
            <a className="button" href="https://stefvuck.dev/" target="_blank" rel="noopener noreferrer">Stefan Vučković</a>
            <a className="button" href="https://vyrz.dev" target="_blank" rel="noopener noreferrer">Benjamin Parsons-Willis</a>
        </div>
    );
}